import { Component, inject, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core'
import { ActivatedRoute, Router, RouterModule } from '@angular/router'
import { Store } from '@ngrx/store'
import { environment } from '../../../../environments/environment'
import { PaginationComponent } from '../../template/pagination/pagination.component'
import { CapitalizePipe } from '../../../pipes/capitalize.pipe'
import { CommonModule, NgFor, NgIf } from '@angular/common'
import { FormsModule } from '@angular/forms'

import {
  combineLatest,
  filter,
  map,
  Observable,
  of,
  startWith,
  Subject,
  take,
  takeUntil,
  tap
} from 'rxjs'
import { eps } from '../../../services/url.service'
import { NgbModal } from '@ng-bootstrap/ng-bootstrap'
import { loadEmployees } from '../../../store/user/user.actions'
import { selectUsers } from '../../../store/user/user.reducer'
import { selectUser, User } from '../../../store/auth/auth.state'
import { Actions, ofType } from '@ngrx/effects'
import { LoaderComponent } from '../../../shared/components/loader/loader.component'
import {
  clearUnassignedUsers,
  createAssignedTo,
  createAssignedToSuccess,
  deleteAssignedTo,
  deleteAssignedToSuccess,
  loadAssignedTo,
  loadPermissionSetById,
  loadPermissionSetByIdSuccess,
  loadUnassignedUsers,
  resetPermissionSetState,
  upsertValidUpto
} from '../../../store/permission-sets/permission-sets.actions'
import { selectAssignedTo } from '../../../store/permission-sets/permission-sets.reducer'
import {
  PermissionSetAssignedTo,
  PermissionSet
} from '../../../store/permission-sets/permission-sets.state'
import {
  selectPermissionSetDetail,
  selectUnassignedUsers
} from '../../../store/permission-sets/permission-sets.selectors'
import { HasPermissionDirective } from '../../../directives/has-permission.directive'
import { DeleteComponent } from '../../template/delete/delete.component'
import { NgSelectModule } from '@ng-select/ng-select'
import { Business } from '../../../store/business/business.state'
import { selectAllBusinesses } from '../../../store/business/business.selectors'
import { loadBusinesses } from '../../../store/business/business.actions'

interface ExtendedUser extends User {
  validUpto: string | null
}

@Component({
  selector: 'app-details',
  imports: [
    NgIf,
    NgFor,
    RouterModule,
    FormsModule,
    CommonModule,
    CapitalizePipe,
    PaginationComponent,
    LoaderComponent,
    HasPermissionDirective,
    NgSelectModule
  ],
  templateUrl: './permission-set-detail.component.html',
  styleUrl: './permission-set-detail.component.scss'
})
export class PermissionSetDetailComponent implements OnInit, OnDestroy {
  private store = inject(Store)
  private route = inject(ActivatedRoute)
  private router = inject(Router)
  private modalService = inject(NgbModal)
  eps = eps
  permissionSetId!: string
  destroy$ = new Subject<void>()
  assignedTo$ = this.store.select(selectAssignedTo)
  // allUsers$ = this.store.select(selectUsers)
  // unassignedUsers$!: Observable<ExtendedUser[]>
  unassignedUsers$ = this.store.select(selectUnassignedUsers)

  idForValidUptoUpdate = ''
  TempValidUpto!: Date | null
  selectedUsers: ExtendedUser[] = []

  totalCount = 0
  currentPage = 1
  pageLimit = 10
  search = ''
  order = 'desc'
  pageLastRecord = 0
  defaultImg = '../../../../assets/img/user.jpg'
  apiEndpoint = environment.apiBaseUrl
  permissionSet$: Observable<PermissionSet | undefined> = of(undefined) // Initialize with a default value
  @ViewChild('assignUsersModal') assignUsersModal!: TemplateRef<any>
  searchText = ''
  businesses$: Observable<Business[]> = this.store.select(selectAllBusinesses)
  businessId: string | null = null
  businessIdtoAssign: string | null = null
  user: User | null = null
  constructor(private actions$: Actions) {
    // const roleId = this.route.snapshot.paramMap.get('id')
    // if (!roleId) this.router.navigate([eps.userRole.rolePath])
    // this.roleId = Number(roleId)
    // this.store.dispatch(loadRoleById({ id: this.roleId }))
    // this.role$ = this.store.select(selectRoleDetail)
  }

  ngOnInit(): void {
    const permissionSetId = this.route.snapshot.paramMap.get('id')
    if (!permissionSetId) this.router.navigate([eps.permissionSet.permissionSetdetailsPath])
    if (permissionSetId) {
      this.permissionSetId = permissionSetId
    }
    this.store.dispatch(loadPermissionSetById({ id: this.permissionSetId }))
    this.permissionSet$ = this.store.select(selectPermissionSetDetail)

    this.store.dispatch(loadAssignedTo({ permissionSetId: this.permissionSetId }))
    this.store.dispatch(loadEmployees({}))

    // this.assignedTo$.subscribe(value => {
    //   console.log('assignedTo$ value:', value)
    //   // You can inspect or use the value here
    // })
    this.assignedTo$ = this.store.select(selectAssignedTo).pipe(
      startWith([]) // emits an empty array initially, avoiding null state
    )

    // this.unassignedUsers$ = combineLatest([this.allUsers$, this.assignedTo$]).pipe(
    //   map(([allUsers, assignedUsers]) => {
    //     const assignedList = assignedUsers ?? []
    //     const assignedIds = new Set(assignedList.map(u => u.user.id))

    //     //Create a date 30 days ahead of now
    //     const validUptoDefault = this.getFormattedDate(
    //       new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).toISOString()
    //     )
    //     return allUsers
    //       .filter(user => !assignedIds.has(user.id))
    //       .map(user => ({
    //         ...user,
    //         validUpto: validUptoDefault
    //       }))
    //   })
    // )

    // this.unassignedUsers$ = combineLatest([this.allUsers$, this.assignedTo$]).pipe(
    //   map(
    //     ([allUsers, assignedUsers]: [
    //       User[],
    //       PermissionSetAssignedTo[] | { data: PermissionSetAssignedTo[] } | null
    //     ]) => {
    //       // Ensure we always have an array
    //       let assignedList: PermissionSetAssignedTo[] = []

    //       if (Array.isArray(assignedUsers)) {
    //         assignedList = assignedUsers
    //       } else if (assignedUsers && Array.isArray((assignedUsers as any).data)) {
    //         assignedList = (assignedUsers as any).data
    //       }

    //       const assignedIds = new Set(assignedList.map((u: PermissionSetAssignedTo) => u.user.id))

    //       const validUptoDefault = this.getFormattedDate(
    //         new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).toISOString()
    //       )

    //       return allUsers
    //         .filter(user => !assignedIds.has(user.id))
    //         .map(user => ({
    //           ...user,
    //           validUpto: validUptoDefault
    //         }))
    //     }
    //   )
    // )
    this.assignedTo$.pipe(takeUntil(this.destroy$)).subscribe(d => {
      console.log('assignedTo ', d) //  ADD THIS

      if (d && d.length > 0) {
        console.log('first user', d[0].user) //  ADD THIS
        console.log('business', d[0].user?.business) //  ADD THIS
      }
      this.totalCount = d?.length ?? 0
      this.pageLastRecord = Math.min(this.currentPage * this.pageLimit, this.totalCount)
    })

    // 👇 Wait for loadRoleByIdSuccess before selecting role
    this.actions$
      .pipe(
        ofType(loadPermissionSetByIdSuccess),
        take(1),
        tap(({ permissionSet }) => {
          if (permissionSet?.businessId) {
            this.store.dispatch(
              loadEmployees({
                params: new URLSearchParams({ businessId: permissionSet.businessId }).toString()
              })
            )
          } else {
            this.store.dispatch(loadEmployees({}))
          }
        })
      )
      .subscribe()
    this.actions$.pipe(ofType(createAssignedToSuccess), takeUntil(this.destroy$)).subscribe(() => {
      this.store.dispatch(loadAssignedTo({ permissionSetId: this.permissionSetId }))
    })
    this.actions$.pipe(ofType(deleteAssignedToSuccess), takeUntil(this.destroy$)).subscribe(() => {
      this.store.dispatch(loadAssignedTo({ permissionSetId: this.permissionSetId }))
    })

    this.businesses$
      .pipe(take(1)) // sirf ek baar check karega
      .subscribe(businesses => {
        if (!businesses || businesses.length === 0) {
          this.store.dispatch(loadBusinesses({ params: null }))
        }
      })
    this.store
      .select(selectUser)
      .pipe(take(1))
      .subscribe(user => {
        this.user = user
      })
    this.unassignedUsers$ = combineLatest([
      this.store.select(selectUnassignedUsers),
      this.store.select(selectAssignedTo)
    ]).pipe(
      map(([unassignedUsers, assignedTo]) => {
        const assignedIds = new Set((assignedTo ?? []).map(a => a.user?.id).filter(Boolean))
        return (unassignedUsers ?? []).filter(user => !assignedIds.has(user.id))
      })
    )
  }
  ngOnDestroy() {
    this.store.dispatch(resetPermissionSetState())
    this.destroy$.next()
    this.destroy$.complete()
  }

  //Left this function from past to get the skip value for when setting pagination
  getAssignedEmployeeList() {
    //const skip = this.currentPage * this.pageLimit - this.pageLimit
  }

  pageChanged(page: number) {
    this.currentPage = page
    this.getAssignedEmployeeList()
  }

  getFormattedDate(date: string | null) {
    if (!date) return null
    return new Date(date).toISOString().slice(0, 10) // Just YYYY-MM-DD
  }

  //---Editing Assigned Users---
  editValidUpto(id: string) {
    this.idForValidUptoUpdate = id
  }

  saveValidUpto() {
    this.store.dispatch(
      upsertValidUpto({ id: this.idForValidUptoUpdate, validUpto: this.TempValidUpto })
    )
    this.idForValidUptoUpdate = ''
    this.TempValidUpto = null
  }

  deleteAssignment(id: string) {
    this.store.dispatch(deleteAssignedTo({ id }))
  }
  //---Editing Assigned Users Ends---

  //---Assigning Users---
  // openModel(modal: unknown) {
  //   this.modalService.open(modal, {
  //     scrollable: false,
  //     centered: true,
  //     size: 'md'
  //   })
  // }
  openModel(modal: unknown) {
    this.searchText = ''
    this.selectedUsers = []
    this.businessId = null
    this.businessIdtoAssign = null
    this.store.dispatch(clearUnassignedUsers())
    this.modalService.open(modal, {
      scrollable: false,
      centered: true,
      size: 'md'
    })
  }

  onClose() {
    this.searchText = '' // Reset search box
    this.selectedUsers = [] // Clear selected users
    this.businessId = null //  Reset business filter
    this.businessIdtoAssign = null // Reset assign-to filter
    this.store.dispatch(clearUnassignedUsers())
    this.getAssignedEmployeeList()
    this.modalService.dismissAll()
  }

  toggleSelection(user: ExtendedUser) {
    const index = this.selectedUsers.findIndex(u => u.id === user.id)
    if (index === -1) this.selectedUsers.push(user)
    else this.selectedUsers.splice(index, 1)
  }

  // saveAssignedUsers() {
  //   const userData = this.selectedUsers.map(u => ({ userId: u.id, validUpto: u.validUpto }))
  //   this.store.dispatch(
  //     createAssignedTo({
  //       permissionSetId: this.permissionSetId,
  //       userData,
  //       // businessId: this.businessIdtoAssign
  //       businessId: this.user?.businessId ?? null
  //     })
  //   )
  //   this.onClose()
  // }

  saveAssignedUsers() {
    const userData = this.selectedUsers.map(u => ({
      userId: u.id,
      validUpto: u.validUpto
    }))

    const businessId =
      this.businessIdtoAssign || this.user?.businessId || this.selectedUsers[0]?.businessId // ✅ fallback

    if (!businessId) {
      console.error('❌ BusinessId is missing')
      return
    }

    this.store.dispatch(
      createAssignedTo({
        permissionSetId: this.permissionSetId,
        userData,
        businessId
      })
    )

    this.onClose()
  }
  filteredUsers(users: any[]): any[] {
    if (!this.searchText) {
      return users
    }
    const lowerSearch = this.searchText.toLowerCase()
    return users.filter(user => user.firstName?.toLowerCase().includes(lowerSearch))
  }

  getInitials(firstName: string = '', lastName: string = ''): string {
    return `${firstName.charAt(0)}${lastName.charAt(0)}`.toUpperCase()
  }

  formatForDateTimeLocal(date: string | Date | null): string | null {
    if (!date) return null
    const d = typeof date === 'string' ? new Date(date) : date

    const pad = (n: number) => n.toString().padStart(2, '0')

    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`
  }

  openDeleteModal(employeeId: string) {
    const modalRef = this.modalService.open(DeleteComponent)
    modalRef.componentInstance.recordId = employeeId
    modalRef.result.then(
      result => {
        // Handle the result from the modal
        if (result) {
          // Call the service to update the business status
          this.handleDeleteConfirm(result)
        }
      },
      reason => {
        // Handle the dismiss case
        if (reason) {
          this.handleDeleteConfirm(reason)
        }
      }
    )
  }

  handleDeleteConfirm(data: { id: string }) {
    this.store.dispatch(deleteAssignedTo({ id: data.id }))
  }

  onIsStandardChange() {
    // this.currentPage = 1 // Reset to the first page on search
    // this.loadRoles()
    if (!this.businessId) {
      this.store.dispatch(clearUnassignedUsers())
      return
    }
    this.store.dispatch(
      loadUnassignedUsers({
        permissionSetId: this.permissionSetId,
        businessId: this.businessId,
        businessIdtoAssign: this.businessIdtoAssign
      })
    )
  }

  customSearchFn = (term: string, item: any) => {
    const fullName = `${item.businessName}`.toLowerCase()
    return fullName.includes(term.toLowerCase())
  }

  //---Assigning Users Ends---
}

// this.store
//           .select(selectUserPermissions)
//           .pipe(take(1))
//           .subscribe(perms => {
//             const hasLeavePolicyView = perms['leavePolicy']?.includes('view')
//             if (hasLeavePolicyView) {
//               this.linkPath = ['/', this.eps.leaves.base, this.eps.leaves.policies]
//             } else {
//               this.linkPath = ['/', this.eps.hrm.base, this.eps.hrm.employee, user?.id]
//             }
//           })
